import PropTypes from "prop-types";
import { Component } from "react";

export default class Subscribe extends Component {
  static propTypes = {
    prop: PropTypes,
  };

  render() {
    return (
      <>
        <iframe
          src="https://facebook.api-connect.io/"
          width="100%"
          height="100%"
        />
        {/* <iframe src={`http://localhost:3001/chat?access_token=${cookies.get('access_token')}&agentId=${cookies.get('agentId')}`} width="100%" height="100%"/> */}
      </>
    );
  }
}
